import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { BrandLockup } from "@/components/Brand";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", password: "", mobile: "" });
  const [loading, setLoading] = useState(false);
  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register(form);
      toast.success("Account created!");
      nav(`/${u.role}`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 p-6 sm:p-8">
      <div className="mb-6">
        <Link to="/"><BrandLockup variant="dark" /></Link>
      </div>
      <Card className="w-full max-w-lg border-slate-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-2xl font-semibold" style={{fontFamily:'Outfit'}}>Create your borrower account</CardTitle>
          <p className="text-sm text-slate-500">It takes less than a minute. You can complete your full profile inside the app.</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Full legal name</Label>
              <Input data-testid="register-name-input" value={form.full_name} onChange={onChange("full_name")} required />
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <Label>Email</Label>
                <Input data-testid="register-email-input" type="text" value={form.email} onChange={onChange("email")} required />
              </div>
              <div>
                <Label>Mobile number</Label>
                <Input data-testid="register-mobile-input" value={form.mobile} onChange={onChange("mobile")} placeholder="+1 555 …" />
              </div>
            </div>
            <div>
              <Label>Password</Label>
              <Input data-testid="register-password-input" type="password" value={form.password} onChange={onChange("password")} required minLength={6} />
              <p className="text-xs text-slate-500 mt-1">At least 6 characters.</p>
            </div>
            <Button disabled={loading} type="submit" data-testid="register-submit-btn" className="w-full text-white hover:opacity-90" style={{background: "linear-gradient(90deg, #0A1F44 0%, #143b8a 100%)"}}>
              {loading ? "Creating…" : "Create account"}
            </Button>
            <p className="text-sm text-slate-500 text-center">
              Already have one? <Link className="font-medium hover:underline" style={{color: "#0A1F44"}} to="/login" data-testid="register-login-link">Sign in</Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
